import 'rxjs/add/observable/of';
import 'rxjs/add/observable/empty';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/catch';

import { Observable } from 'rxjs/Observable';
import { log } from '@atlassian/jira-common-util-logging';
import { issueChildrenInFinalColumnService } from '../../services/issue/issue-children-in-final-column-service';
import { makeServiceContext } from '../../services/service-context';
import {
	type IssueChildrenInFinalColumnRequestAction,
	ISSUE_CHILDREN_IN_FINAL_COLUMN_REQUEST,
} from '../../state/actions/issue-children';
import { showUpdateIssueParentModal } from '../../state/actions/issue/update-issue-parent-modal';
import type { Action, ActionsObservable, MiddlewareAPI } from '../../state/types';

export function issueChildrenInFinalColumnEpic(
	action$: ActionsObservable,
	store: MiddlewareAPI,
): Observable<Action> {
	return action$
		.ofType(ISSUE_CHILDREN_IN_FINAL_COLUMN_REQUEST)
		.mergeMap((action: IssueChildrenInFinalColumnRequestAction) => {
			const ctx = makeServiceContext(store.getState());

			return issueChildrenInFinalColumnService(ctx, action.payload.parentId)
				.flatMap(({ subtasksInFinalColumn }) => {
					if (subtasksInFinalColumn) {
						return Observable.of(showUpdateIssueParentModal(action.payload.parentId));
					}

					return Observable.empty<never>();
				})
				.catch((err) => {
					log.safeErrorWithoutCustomerData(
						'issue.issue-children-in-final-column.failure',
						'Failed to check if all issue children are in final column',
						err,
					);
					return Observable.empty<never>();
				});
		});
}
